"use strict";

initVisPdf();

function initVisPdf() {
    $("#pdfframe").on("load", function() {
        $("#spinner").remove();
    });
}


//////////////////
// WEBPACK FOOTER
// ./Content/scripts/vispdf.js
// module id = 0
// module chunks = 5